<template>
  <div id="AddWriter" class="wrap">

    <v-app-bar class="grey lighten-3 desktopHeader--remove hidden-md-and-up " fixed elevate-on-scroll>
      <v-layout justify-center align-center>
        <span class="title blue--text text--darken-3 ml-1"> Add Evaluation Writer</span>
      </v-layout>
    </v-app-bar>
    <div class="maxContainer">
      <div class="HealthcareHours__cover offset-md-3 col-md-6 offset-sm-2 col-sm-8 ">
        <div @click="backDesktop" class="headerFake__back">
          <a class="headerFake__backLink">
            <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
            <span class="headerFake__backText">Back</span>
          </a>
        </div>
        <v-card class=" mb-5 pt-5" flat >

          <v-card-text class="mt-0 pt-0 px-0"> 
            <v-layout justify-center align-center class="mb-3 hidden-sm-and-down">
              <span class="title blue--text text--darken-3 ml-1"> Add Evaluation Writer</span>
            </v-layout>
            <!-- Evaluation Writer Container-->
            <v-container grid-list-md pt-0 px-1>
              <v-form >
                <!-- Writer Name -->
                <v-flex xs12>
                  <v-text-field
                    v-model="writer_name"               
                    label="Name"
                    outlined>
                  </v-text-field>
                </v-flex>

                <!-- Writer Title -->
                <v-flex xs12>
                  <v-select
                    v-model="writer_title"
                    :items="['PA', 'MD', 'DO', 'NP', 'PhD', 'Other Medical Professional', 'University Professor', 'Science Professor', 'Employer/Supervisor', 'Non-Relative']"
                    label="Title"
                    outlined
                  ></v-select>
                </v-flex>

                <!-- Time Known-->
                <v-flex xs12>
                  <v-text-field
                    v-model="writer_time_known"
                    label="Time Known (months)" 
                    outlined
                  ></v-text-field>
                </v-flex>

                <!-- Writer Email-->
                <v-flex xs12>
                  <v-text-field
                    v-model="writer_email"
                    label="Email" 
                    outlined
                  ></v-text-field>
                </v-flex>

                <!-- Writer Phone-->
                <v-flex xs12>
                    <v-text-field
                      v-model="writer_phone"
                      label="Phone Number" 
                      outlined
                    ></v-text-field>
                </v-flex>
              </v-form>

              <!-- Add PA Button -->
              <v-layout row class="mt-2 mb-3">
                <v-btn
                  color="green"
                  @click="addWriter"
                  block
                  large
                  >
                  <span class="white--text"> Save</span>
                </v-btn>
              </v-layout>
            </v-container>

          </v-card-text>
        </v-card>
      </div>
    </div>

    <!-- Back Button -->
    <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>
    
  </div>

</template>

<script>
  export default {
     data() {
      return {
        modal: false,
        alert: false,
        AddEvaluationWriterDialog: false,
        writer_name : '',
        writer_title: '',
        writer_email: '',
        writer_phone: '',
        writer_time_known: '',
      }
    },
    methods: {
      back() {
        this.$router.go(-1);
      },
      backDesktop () {
        this.$router.push('/dashboard')
      },
      showAddEvaluationWriterDialog(user) {
        if(user !== null && user !== undefined ){
          this.AddEvaluationWriterDialog = true
        }
        else {
          this.alert = true
          console.log('not logged in')
        }
      },
      addWriter () {
        const writerData = {
          writer_name : this.writer_name,
          writer_title: this.writer_title,
          writer_email: this.writer_email,
          writer_phone: this.writer_phone,
          writer_time_known: this.writer_time_known,
          evaluation_status: 'Not Yet Requested'  
        }
        
        this.$store.dispatch('setEvaluationWriter', writerData)

        if( window.innerWidth < 960 ) {
          this.$router.push('/dashboard/evaluations')
        } else {
          this.$router.push('/dashboard')
        }

        this.writer_name = '',
        this.writer_title = '',
        this.writer_email = '',
        this.writer_phone = '',
        this.writer_time_known = '',
        this.evaluation_status = ''
      }
    },
    computed : {
      user () {
        return this.$store.getters.user
      },

    },
  }
</script>

<style scoped>
.fixed {
  position: fixed;
  bottom: 0;
  right: 0;
  margin-bottom:65px;    
}

#buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}
@media (min-width: 960px) {
  .desktopHeader {
    width: calc(100% - 256px);
    margin-left: 256px;
  }
}
 
.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.wrap {
  margin-top: 8vh !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Evaluations/AddEvaluationWriter.vue